import { api } from "..";

interface Payload {
  couponIds: string[];
}

export const clearCoupons = async (
  payload: Payload
): Promise<{ success: boolean }> => {
  const res = await api.client.post(
    "/users-new/coupons/bulk-delete",
    payload
  );
  return res.data;
};
